import { render } from "./Policy.vue?vue&type=template&id=6652965a&scoped=true"
const script = {}

import "./Policy.vue?vue&type=style&index=0&id=6652965a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6652965a"

export default script